import { isStagingOrLocal } from "@softr-io/blocks-sdk";
import { DEVELOPER_MODE_FLAG, getFeatureFlag } from "@softr/utils";

export const log = {
    info(...args: unknown[]) {
        console.info("INFO", "SPR", ...args);
    },
    debug(...args: unknown[]) {
        // eslint-disable-next-line no-console
        console.debug("DEBUG", "SPR", ...args);
    },
    error(...args: unknown[]) {
        console.error("ERROR", "SPR", ...args);
    },
    warn(...args: unknown[]) {
        console.warn("WARN", "SPR", ...args);
    },
};

/**
 * The browser keeps the arguments of the last console messages alive, also with DevTools closed,
 * and its size limit counts only the shallow size of an argument.
 */
export function isHeavyLoggingEnabled() {
    return isStagingOrLocal() || isSoftrEmployee() || getFeatureFlag(DEVELOPER_MODE_FLAG);
}

function isSoftrEmployee() {
    return !!window.logged_in_user?.softr_user_email?.endsWith("@softr.io");
}
